import React, { useEffect } from 'react';
import { usePlayerStore } from '../../stores/playerStore';
import { radioService } from '../../api/radioService';
import { useAudioPlayer } from '../../hooks/useAudioPlayer';
import { logger } from '../../utils/logger';

/**
 * Headless audio driver for the mobile bar — it renders nothing and exists only
 * to keep the shared audio engine wired up while the mobile UI is mounted.
 *
 * It previously carried a full duplicate of DesktopPlayerBar's playback logic,
 * including its own `new Audio()`, its own Hls instance and its own retry loop.
 * Both copies had the same stale-closure bug (handlers registered in an empty-dep
 * useEffect captured the first station forever), so an error on one station would
 * restart whichever station happened to be playing when the bar first mounted.
 */
const MobilePlayer: React.FC = () => {
  const currentStation = usePlayerStore((state) => state.currentStation);

  useAudioPlayer();

  useEffect(() => {
    if (!currentStation) return;
    radioService
      .reportStationClick(currentStation.stationuuid)
      .catch((error) => logger.error('Failed to report station click:', error));
  }, [currentStation?.stationuuid]);

  return null;
};

export default MobilePlayer;
